import { Card, CardContent } from "@/components/ui/card"

// Card de un partido
export const BracketMatch = ({ match, onUpdateScore, onReport, innerRef }) => {
  const { player1, player2, reported } = match

  return (
    <Card ref={innerRef} className={`w-56 shadow-sm relative z-10 ${reported ? "opacity-60" : ""}`}>
      <CardContent className="p-2">
        <div className="flex flex-col gap-2">
          <div className="flex justify-between items-center">
            <span>{player1.name}</span>
            <input
              type="number"
              value={player1.score}
              max={2}
              min={0}
              onChange={(e) => onUpdateScore(player1.id, parseInt(e.target.value) || 0)}
              className="w-12 border rounded text-center"
              disabled={!match.editable}
            />
          </div>
          <div className="flex justify-between items-center">
            <span>{player2.name}</span>
            <input
              type="number"
              value={player2.score}
              max={2}
              min={0}
              onChange={(e) => onUpdateScore(player2.id, parseInt(e.target.value) || 0)}
              className="w-12 border rounded text-center"
              disabled={!match.editable}
            />
          </div>
          <button
            className="mt-2 w-full bg-blue-500 text-white py-1 rounded disabled:bg-gray-400"
            onClick={onReport}
            disabled={reported}
          >
            {reported ? "Reportado" : "Reportar"}
          </button>
        </div>
      </CardContent>
    </Card>
  )
}
